import React, { useEffect, useState, useRef } from "react";
import { Card, CardBody, CardHeader } from "./../../components/card/card.jsx";
import { machineProfile } from "../../api/index.js";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/AuthContext.jsx";
import {
  dateToToday,
  formatDateOnly,
  generateLocationToArray,
  printLocation,
} from "../../utils/helper.jsx";
import { useDashboardContext } from "../../contexts/NewDashboardContext.jsx";
import { useNavigate, useRoutes } from "react-router-dom";
import { MachineProfile } from "../../api/machine_profile.js";
import ConfirmationDlg from "../../components/ConfirmationDlg/index.jsx";
import { Loader } from "../../utils/helper";
import DataTable from "react-data-table-component";
import { LocationFilter } from "../../components/LocationFilter/index.jsx";
import ImageViewer from "../../components/ImageViewer";
import SideBarLocation from "../../components/SideBarLocation";

function MachineList() {
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState({ company: true });
  const { config } = useAuth();
  const { machineTypes } = useDashboardContext();
  const [deleteRow, setDeleteRow] = useState(null);
  const [changeStatus, setChangeStatus] = useState(null);
  const { updateMachineProfile } = useAuth();
  const canUpdate = updateMachineProfile();
  const navigate = useNavigate();

  async function getMachine() {
    try {
      setLoading(true);
      const queryParam = {
        ...query,
      };
      const res = await machineProfile.list(queryParam);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data) {
          data.forEach((d) => {
            const locationNameArr = [];
            generateLocationToArray(d.location, locationNameArr);
            d.location_arr = locationNameArr.reverse();
          });
          setDatas(data);
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }

  function changeOperation(value) {
    openChangeStatus(value);
  }

  function generateLocationWording() {
    let result = [];
    if (config && config?.location_wording) {
      const words = config?.location_wording.split(",");
      words.forEach((ln, index) => {
        result.push(ln);
      });
    }

    return result;
  }

  const ExpandedComponent = ({ data }) => {
    return (
      <div style={{ padding: "10px" }}>
        <Card className="border-theme">
          <CardBody>
            <div className={"row"}>
              <div className="col-md-3">
                <ImageViewer src={data?.attachments?.filePhoto}></ImageViewer>
              </div>
              <div className="col-md-9">
                <div>
                  Machine Name : <b>{data.machine_name}</b>
                </div>
                <hr />
                <div>Sensor Online Status</div>
                {data?.machine_status === "Operational" ? (
                  <div className="mb-2">
                    <table>
                      {data.machine_elements.map((cm, index) => (
                        <tr key={index}>
                          <td
                            style={{
                              width: "100px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {" "}
                            {cm.machine_element_name}
                          </td>
                          <td>
                            <i className="fa fa-chevron-right"></i>
                          </td>
                          <td style={{ padding: "0 5px" }}>
                            <span
                              className={`custom-chip tableFontSize ${
                                cm.deployments[0]?.sensor?.sensor_uptime[0]
                                  ?.on_off_status === "true"
                                  ? "chip-green"
                                  : "chip-red"
                              }`}
                              style={{
                                padding: "1px 15px 1px 15px",
                                color: "#040930",
                                background:
                                  cm.deployments[0]?.sensor?.sensor_uptime[0]
                                    ?.on_off_status === "true"
                                    ? "#71c56b"
                                    : "#ff8c87",
                                fontSize: "11px",
                              }}
                            >
                              {cm.deployments[0]?.sensor?.sensor_uptime[0]
                                ?.on_off_status === "true"
                                ? "Online"
                                : "Offline"}
                            </span>
                          </td>
                          <td>
                            {cm.deployments[0]?.sensor?.sensor_uptime[0]
                              ?.on_off_status === "true" ? null : (
                              <div>
                                <div style={{ fontSize: "10px" }}>
                                  Last Active
                                </div>
                                <div style={{ fontSize: "12px" }}>
                                  {formatDateOnly(
                                    cm.deployments[0]?.sensor?.sensor_uptime[0]
                                      ?.start_date
                                  )}
                                </div>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                    </table>
                  </div>
                ) : (
                  <div className="mt-3 mb-3 text-underline">
                    <h4>
                      {" "}
                      <b>- In {data?.machine_status} Status -</b>
                    </h4>
                  </div>
                )}

                <button
                  style={{ marginRight: "10px" }}
                  onClick={() => navigate("/machine/" + data.id)}
                  type="button"
                  className="btn btn-outline-theme"
                >
                  Machine Profile
                </button>
                <button
                  onClick={() => navigate("/sensor/live/" + data.id)}
                  style={{ marginRight: "10px" }}
                  type="button"
                  className="btn btn-outline-theme"
                >
                  View Live Sensor Data
                </button>
                {canUpdate && (
                  <button
                    onClick={() => navigate("/machine/edit/" + data.id)}
                    type="button"
                    style={{ marginRight: "10px" }}
                    className="btn btn-outline-theme"
                  >
                    <i className="fa fa-edit"></i> Edit machine
                  </button>
                )}
                {canUpdate && (
                  <button
                    onClick={() => {
                      changeOperation(data);
                    }}
                    type="button"
                    className="btn btn-outline-theme"
                  >
                    <i className="fa fa-edit"></i> Change Operation Status
                  </button>
                )}
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  };

  function showConfirmationDlg(row) {
    setDeleteRow(row);
  }

  function hideConfirmationDialog() {
    setDeleteRow(null);
  }

  function openChangeStatus(value) {
    setChangeStatus(value);
  }

  function hideChangeStatus() {
    setChangeStatus(null);
  }

  function countOnlineOffline(machine) {
    let online = 0;
    let offline = 0;
    machine.machine_elements.forEach((cm) => {
      if (
        cm.deployments[0]?.sensor?.sensor_uptime[0]?.on_off_status === "true"
      ) {
        online++;
      } else {
        offline++;
      }
    });
    return { online, offline };
  }

  async function deleteMachinProfile() {
    try {
      const response = await MachineProfile.delete(deleteRow.id);
      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success("This machine profile has been deleted");

          setDeleteRow(null);
        } else {
          toast.error(body.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  const columns = [
    ...generateLocationWording().map((w, i) => ({
      name: w,
      grow: 1,
      selector: (row) => printLocation(row.location_arr[i]),
    })),
    {
      name: "Machine Name",
      selector: (row) => row.machine_name,
      minWidth: "250px",
    },
    {
      name: "Machine Type",
      selector: (row) => row.machine_type.name,
    },
    {
      name: "Sensor Online Status",
      minWidth: "200px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => (
        <div>
          {row.machine_status === "Operational" ? (
            <div>
              {countOnlineOffline(row).offline === 0 ? (
                <span
                  style={{
                    padding: "1px 15px 1px 15px",
                    color: "#040930",
                    background: "#71c56b",
                  }}
                >
                  All Online
                </span>
              ) : (
                <>
                  <span
                    style={{
                      padding: "1px 15px 1px 15px",
                      color: "#040930",
                      background: "#71c56b",
                    }}
                  >
                    {countOnlineOffline(row).online} Online
                  </span>{" "}
                  -
                  <span
                    style={{
                      padding: "1px 15px 1px 15px",
                      color: "#040930",
                      background: "#ff8c87",
                    }}
                  >
                    {countOnlineOffline(row).offline} Offline
                  </span>
                </>
              )}
            </div>
          ) : (
            <div className="text-underline">
              <b>- In {row?.machine_status} Status -</b>
            </div>
          )}
        </div>
      ),
    },
  ];

  const handleChangeLocationFilter = (location_id) => {
    setQuery((prev) => ({
      ...prev,
      location_id: location_id ? location_id : "",
    }));
  };

  const handleChangeMachineType = (machine_type_id) => {
    setQuery((prev) => ({
      ...prev,
      machine_type_id: machine_type_id,
    }));
  };

  useEffect(() => {
    getMachine();
    // eslint-disable-next-line
  }, [query]);

  const onChangeStatus = (e) => {
    setChangeStatus((prev) => ({
      ...prev,
      machine_status: e.target.value,
    }));
  };

  const prosesChangeStatus = async () => {
    try {
      const response = await machineProfile.updateStatus(
        changeStatus.id,
        changeStatus.machine_status
      );
      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success("Machine Status has been changed");

          setChangeStatus(null);
        } else {
          toast.error(body.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">MACHINE</a>
            </li>
            <li className="breadcrumb-item active">MACHINE LIST</li>
          </ul>

          <h1 className="page-header">Machine List</h1>

          <hr className="mb-4" />

          <div id="datatable" className="mb-5">
            <div className="row mb-2 justify-content-sm-end">
              <div className="col-sm-3 mb-2 mb-sm-0">
                <LocationFilter onChange={handleChangeLocationFilter} />
              </div>
              <div className="col-sm-3 mb-2 mb-sm-0">
                <select
                  className="form-select btn btn-sm btn-outline-theme"
                  defaultValue=""
                  onChange={(e) => {
                    handleChangeMachineType(e.target.value);
                  }}
                >
                  <option value="">- Machine Type -</option>
                  {machineTypes.map((mt) => (
                    <option key={mt.id} value={mt.id}>
                      {mt.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-sm-3 mb-2 mb-sm-0">
                <button
                  onClick={() => {
                    navigate("/machine/add");
                  }}
                  className="btn btn-outline-theme w-100"
                >
                  Add Machine <i className="bi bi-plus"></i>
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Card>
                  <CardBody>
                    <Loader loading={loading}>
                      <DataTable
                        highlightOnHover
                        expandOnRowClicked
                        expandableRowsHideExpander
                        expandableRows
                        expandableRowsComponent={ExpandedComponent}
                        theme="dark"
                        columns={columns}
                        data={datas}
                        pagination
                      />
                    </Loader>
                  </CardBody>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>

      {deleteRow && (
        <ConfirmationDlg
          title={"Delete Machine Profile"}
          open={!!deleteRow}
          onClose={hideConfirmationDialog}
          onSubmit={deleteMachinProfile}
        >
          <p style={{ pb: 2 }}>
            Are you sure you want to delete this Machine Profile{" "}
            <strong>{deleteRow.machine_name}</strong> ?
          </p>
        </ConfirmationDlg>
      )}
      {changeStatus && (
        <ConfirmationDlg
          title={"Change Machine Status"}
          open={!!changeStatus}
          onClose={hideChangeStatus}
          btnSubmitText={"Update"}
          btnCancelText={"Cancel"}
          onSubmit={prosesChangeStatus}
        >
          <p style={{ pb: 2 }}>
            Change Status of <strong>{changeStatus.machine_name}</strong> ?
          </p>
          <div className="form-group">
            <select
              className={"form-select "}
              value={changeStatus?.machine_status}
              onChange={onChangeStatus}
            >
              <option value="Operational">Operational</option>
              <option value="Maintenance">Maintenance</option>
              <option value="Repair">Repair</option>
              <option value="Archived">Archived</option>
            </select>
          </div>
        </ConfirmationDlg>
      )}
    </div>
  );
}

export default MachineList;
